import { Kind } from './events';

// TODO: ALL THE COLORS!
const grey = opacity => `rgba(167, 173, 178, ${opacity})`;
const black = opacity => `rgba(46, 47, 58, ${opacity})`;

const COLORS = {
  black: black('1'),
  black400: black('0.5'),
  black500: black('0.6'),
  black600: black('0.7'),
  black700: black('0.8'),
  black800: black('0.9'),
  blue10: 'rgb(246,248,251)',
  blue50: 'rgb(234,246,250)',
  blue: 'rgb(0,123,244)',
  blue400: 'rgba(71, 122, 174, 0.75)',
  blue500: 'rgb(77, 134, 191)',
  blue600: 'rgb(71, 122, 174)',
  lightBlue500: 'rgb(96, 169, 244)',
  green10: 'rgb(237, 247, 238)',
  green50: 'rgb(219, 242, 220)',
  green100: 'rgb(201, 236, 203)',
  green200: 'rgb(165, 223, 168)',
  green300: 'rgb(128, 210, 133)',
  green400: 'rgb(99, 209, 105)',
  green500: 'rgb(83, 198, 88)',
  green700: 'rgb(74, 192, 79)',
  grey10: 'rgba(250, 251, 251, 0.5)',
  grey10o: 'rgb(253,253,253)',
  grey50: grey('0.1'),
  grey100: grey('0.2'),
  grey150: grey('0.25'),
  grey200: grey('0.3'),
  grey300: grey('0.4'),
  grey400: grey('0.5'),
  grey500: grey('0.6'),
  grey600: grey('0.7'),
  grey700: grey('0.8'),
  grey800: grey('0.9'),
  grey900: grey('1'),
  orange100: 'rgba(255, 152, 0, .2)',
  orange500: 'rgb(255, 152, 0)',
  red100: 'rgb(253, 236, 234)',
  red300: 'rgb(247, 91, 72)',
  red500: 'rgb(244, 67, 54)',
  red700: 'rgb(229, 56, 45)',
  white: 'rgb(255, 255, 255)',
  offWhite: 'rgb(245,249,253)',
  screen: 'rgba(46, 47, 58, .8)',
  slate: 'rgba(106, 110, 117, 1)',
  darkTransparent: 'rgba(46, 47, 58, 0.8)',
};

// 2.6 updates
const OVERRIDES = {
  blue500: 'rgb(0, 150, 247)',
  grey50a: COLORS.grey50, // alpha 0.1
  grey50o: 'rgb(246, 246, 247)', // opaque
};

const colors = {
  ...COLORS,
  ...OVERRIDES,
};

const eventKindColors = {
  [Kind.risk]: colors.orange500,
  [Kind.action]: colors.blue500,
  [Kind.collision]: colors.red500,
  [Kind.subtype]: colors.grey700,
};

const responses = {
  alert: colors.red500,
  success: colors.green500,
  warn: colors.orange500,
};

const states = {
  lost: colors.grey900,
  moving: colors.green500,
  none: colors.red500,
  parked: colors.blue500,
  stopped: colors.green500,
};

export default {
  ...colors,
  ...responses,
  ...states,
  ...eventKindColors,
  brand: colors.green500,
  text: colors.black,
};
